import { Component } from 'react';
import {connect} from 'react-redux';

import './style.css';

class LayoutContainer extends Component {
  render() {
    return (
      <div className={this.props.viewConfig.lockScroll ? 'noscroll' : ''}>
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
});

export default connect(mapStateToProps)(LayoutContainer);
